import './meditar.scss';
import $ from 'jquery';
import 'bootstrap';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel';
import {Howl, Howler} from 'howler';

var sound;
let currentLang = 'es';
let counter; 
var locutor;
var max = 28;

$(document).ready(function(){
	var owl = $('.owl-carousel');
	owl.owlCarousel({
		items: 4,
		nav: true,
		navText : ["<img src='public/images/slider-prev2.png' >","<img src='public/images/slider-next2.png' >"],
		responsive:{
			0:{
				items:1,

			},
			480 : {
				items: 2,
			},
			600:{
				items:3
			},
		}

	});

	var owl2 = $('.otro');
	owl2.owlCarousel({
		items: 2,
		nav: true,
		navText : ["<img src='public/images/slider-prev2.png' >","<img src='public/images/slider-next2.png' >"],
		responsive:{
			0:{
				items:2,

			},
			480 : {
				items: 2,
			},
			600:{
				items:2
			},
		}

	});
	$(".c-next").click(function(){
		owl.trigger('next.owl.carousel');
	})
	$(".c-prev").click(function(){
		owl.trigger('prev.owl.carousel');
	})
	$('.meditar-item').hover(function(){
		$(this).find('.overlay').fadeToggle();
	});

	$('.change').click(function(){
		var lang = $(this).data('lang');
		currentLang = $(this).data('lang');
		if(lang == 'es'){
			max = 28;
		}
		if(lang == 'ds'){
			max = 3;
			locutor = "Vivian Hayd (Comunidad Alemana en Bs. As.)";
		}
		if(lang == 'en'){
			max = 3;
			locutor = "Nicole Bertein (desde Australia)";
		}
		if(lang == 'fr'){
			locutor = "Luciana Volco (desde Francia)";
			max = 3;
		}
		if(lang == 'it'){
			max = 3;
			locutor = "Gabriella Bianco y Ariana Bonato (desde España)";
		}
		
		$('.lang').removeClass('active');
		$(this).addClass('active');
		$('.owl-carousel').hide();
		$('#'+lang).show();
		$('#locutor').html(locutor);
	});
	

	$('.open-modal').click(function(){
		
		var meditacion = $(this).data('audio');
		counter = $(this).data('audio');
		$('audio').attr('src', 'public/audio/'+currentLang+'/'+meditacion+'.mp3');
		/*sound = new Howl({
			src: ['public/audio/'+currentLang+'/'+meditacion+'.mp3']
		});*/
		var autor = $(this).data('autor');
		$('.meditacion-img').attr('src', 'public/images/meditaciones/'+currentLang+'/' + meditacion + '.jpg');
		$('#meditacion-numero').html('Día '+meditacion);
		$('#artista').html('Artista: '+autor);
		$('.modal').modal('show');
	});


	$('.next').click(function(){
		if(counter < max){
			counter++;
			$('#meditacion-numero').html('Día '+counter);
			$('.meditacion-img').attr('src', 'public/images/meditaciones/'+currentLang+'/' + counter + '.jpg');
			let au = $("#"+currentLang).find(`[data-audio='${counter}']`).data('autor');
			$('#artista').html('Artista: '+au);

			$('audio').attr('src', 'public/audio/'+currentLang+'/'+counter+'.mp3');

		}
		
	});

	$('.prev').click(function(){
		if(counter > 1){
			counter--;
			$('#meditacion-numero').html('Día '+counter);
			$('.meditacion-img').attr('src', 'public/images/meditaciones/'+currentLang+'/' + counter + '.jpg');
			let au = $("#"+currentLang).find(`[data-audio='${counter}']`).data('autor');
			$('#artista').html('Artista: '+au);
			$('audio').attr('src', 'public/audio/'+currentLang+'/'+counter+'.mp3');
		}
	});

});
